import { render, staticRenderFns } from "./CustomTitleDivider.vue?vue&type=template&id=bf19cdec&scoped=true"
import script from "./CustomTitleDivider.vue?vue&type=script&lang=js"
export * from "./CustomTitleDivider.vue?vue&type=script&lang=js"
import style0 from "./CustomTitleDivider.vue?vue&type=style&index=0&id=bf19cdec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf19cdec",
  null
  
)

export default component.exports